import type { GetImpactListResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetImpactListQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactListDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetImpactList = createQueryHook<
  Record<string, never>,
  GetImpactListResponseRow[],
  GetImpactListQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.impact.impactList.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({ impact: data }),
  graphqlDocument: GetImpactListDocument,
});
